/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';

interface ITerminateFormModalProps {
  FIELDS: any[];
  layout: any;
  onTerminateFormSubmit?(data: any): void;
  onHideClick?(): void;
  submitButtonTitle?: string;
  modalTitle?: string;
}

export const TerminateFormModal = (props: ITerminateFormModalProps) => {
  const {
    FIELDS,
    layout,
    onTerminateFormSubmit,
    onHideClick,
    submitButtonTitle,
    modalTitle,
  } = props;

  return (
    <div style={{ display: '' }}>
      <TweetyModal
        show={true}
        size={'lg'}
        scrollable={false}
        backdrop={'static'}
        submitButtonTitle={submitButtonTitle}
        onSubmit={onTerminateFormSubmit}
        onHide={onHideClick}
        title={modalTitle}
        tweetyWidgetProps={{
          fields: FIELDS,
          layout,
        }}
      />
    </div>
  );
};

TerminateFormModal.defaultProps = {
  submitButtonTitle: 'Terminate',
  modalTitle: 'Terminate Work Permit',
};
